'use strict';
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits from "./com.raquo.laminar.api.-Implicits.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024 from "./com.raquo.laminar.modifiers.-Renderable-Seq$collection-Seq-Renderable$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dField$002dName from "./dev.cheleb.scalamigen.-Field-Name.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00241 from "./dev.cheleb.scalamigen.-Form$$anon$1.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dName$002dUtils$0024 from "./dev.cheleb.scalamigen.-Name-Utils$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dNo$002dPanel from "./dev.cheleb.scalamigen.-No-Panel.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dPanel from "./dev.cheleb.scalamigen.-Panel.js";
import * as $j_dev$002echeleb$002escalamigen$002econfig$002e$002dPanel$002dConfig from "./dev.cheleb.scalamigen.config.-Panel-Config.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dI$002dArray$0024package$0024$002dI$002dArray$0024 from "./scala.-I-Array$package$-I-Array$.js";
import * as $j_scala$002e$002dOption$0024 from "./scala.-Option$.js";
import * as $j_scala$002e$002dSymbol$0024 from "./scala.-Symbol$.js";
import * as $j_scala$002e$002dTuple$0024 from "./scala.-Tuple$.js";
import * as $j_scala$002e$002dUniqueness$002dCache from "./scala.-Uniqueness-Cache.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
import * as $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024 from "./scala.util.control.-Non-Fatal$.js";
var $p;
function $p_Ldev_cheleb_scalamigen_Form$$anon$12__fieldNameFromParam__Lmagnolia1_CaseClass$Param__T($thiz, param) {
  var arr = param.Kn;
  _return: {
    var i = 0;
    while ((i < $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(arr))) {
      if (($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aQ(arr, i) instanceof $j_dev$002echeleb$002escalamigen$002e$002dField$002dName.$c_Ldev_cheleb_scalamigen_FieldName)) {
        var idx = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var idx = (-1);
  }
  var x75 = ((idx === (-1)) ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aQ(arr, idx)));
  if (($j_java$002elang$002e$002dObject.$m_s_None$() === x75)) {
    var this$6 = param.rq().dJ();
    return (this$6.k() ? $j_dev$002echeleb$002escalamigen$002e$002dName$002dUtils$0024.$m_Ldev_cheleb_scalamigen_NameUtils$().Y0(param.k7) : this$6.C());
  }
  if ((x75 instanceof $j_java$002elang$002e$002dObject.$c_s_Some)) {
    return x75.Q.H7;
  }
  throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x75);
}
export { $p_Ldev_cheleb_scalamigen_Form$$anon$12__fieldNameFromParam__Lmagnolia1_CaseClass$Param__T as $p_Ldev_cheleb_scalamigen_Form$$anon$12__fieldNameFromParam__Lmagnolia1_CaseClass$Param__T };
function $p_Ldev_cheleb_scalamigen_Form$$anon$12__mkVariableForParam__Lcom_raquo_airstream_state_Var__Lmagnolia1_CaseClass$Param__Lcom_raquo_airstream_state_Var($thiz, variable, param) {
  return $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(variable, new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => {
    try {
      var $x_1 = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(param.xc(a$2));
    } catch (e) {
      var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
      matchResult1: {
        var $x_1;
        var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
        if ((!x2.k())) {
          var $x_1 = new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
          break matchResult1;
        }
        throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
      }
    }
    return $x_1.P9(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => param.Ty())));
  })), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$12$2, value$2) => {
    var this$7 = $thiz.jL;
    var f = ((p$2) => ((p$2.k7 === param.k7) ? value$2 : p$2.xc(variable.a4().b3().C())));
    var $x_14 = this$7.Kr;
    var $x_13 = $j_scala$002e$002dTuple$0024.$m_T$();
    var arr = this$7.mh;
    var len = arr.a.length;
    var ys = new $j_java$002elang$002e$002dObject.$ac_O(len);
    if ((len > 0)) {
      var i = 0;
      if ((arr !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = arr.a[i];
          ys.a[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = arr.a[i];
          ys.a[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = arr.a[i];
          ys.a[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
        while ((i < len)) {
          var $x_7 = i;
          var $x_5 = arr.a;
          var $x_6 = (i << 1);
          var x0$3_$_lo = $x_5[$x_6];
          var x0$3_$_hi = $x_5[(($x_6 + 1) | 0)];
          ys.a[$x_7] = f($j_java$002elang$002e$002dObject.$bL(x0$3_$_lo, x0$3_$_hi));
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$4 = arr.a[i];
          ys.a[$x_8] = f(x0$4);
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$5 = arr.a[i];
          ys.a[$x_9] = f($j_java$002elang$002e$002dObject.$bC(x0$5));
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$6 = arr.a[i];
          ys.a[$x_10] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
        while ((i < len)) {
          var $x_11 = i;
          var x0$7 = arr.a[i];
          ys.a[$x_11] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
        while ((i < len)) {
          var $x_12 = i;
          var x0$8 = arr.a[i];
          ys.a[$x_12] = f(x0$8);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(arr);
      }
    }
    return $x_14.y($x_13.Uj(ys));
  })));
}
export { $p_Ldev_cheleb_scalamigen_Form$$anon$12__mkVariableForParam__Lcom_raquo_airstream_state_Var__Lmagnolia1_CaseClass$Param__Lcom_raquo_airstream_state_Var as $p_Ldev_cheleb_scalamigen_Form$$anon$12__mkVariableForParam__Lcom_raquo_airstream_state_Var__Lmagnolia1_CaseClass$Param__Lcom_raquo_airstream_state_Var };
function $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsTable$1__Lcom_raquo_airstream_state_Var__Ldev_cheleb_scalamigen_WidgetFactory__Ldev_cheleb_scalamigen_config_PanelConfig__sci_List__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, variable$12, factory$2, panel$1, path$9, errorBus$7) {
  var $x_23 = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.uD();
  var $x_22 = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d;
  var $x_21 = $j_scala$002e$002dI$002dArray$0024package$0024$002dI$002dArray$0024.$m_s_IArray$package$IArray$();
  var arr = $thiz.jL.mh;
  var f = ((param$2) => {
    var isOption = (param$2.xc(variable$12.a4().b3().C()) instanceof $j_java$002elang$002e$002dObject.$c_s_Option);
    var fieldName = $p_Ldev_cheleb_scalamigen_Form$$anon$12__fieldNameFromParam__Lmagnolia1_CaseClass$Param__T($thiz, param$2);
    return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.iw().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.eZ().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [param$2.rq().dx(fieldName, (!isOption), factory$2)])), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.iD.hc(panel$1.lG)])), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.eZ().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(param$2.rq().bt($j_java$002elang$002e$002dObject.$f_sc_StrictOptimizedSeqOps__appended__O__O(path$9, $j_scala$002e$002dUniqueness$002dCache.$c_s_UniquenessCache.prototype.O3.call($j_scala$002e$002dSymbol$0024.$m_s_Symbol$(), fieldName)), $p_Ldev_cheleb_scalamigen_Form$$anon$12__mkVariableForParam__Lcom_raquo_airstream_state_Var__Lmagnolia1_CaseClass$Param__Lcom_raquo_airstream_state_Var($thiz, variable$12, param$2), factory$2, errorBus$7), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.r3().w(param$2.k7)]))]))]));
  });
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.l();
  var len = arr.a.length;
  var componentType = evidence$1__runtimeClass;
  var ys = componentType.J.U(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_2 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_1 = i;
        var x0$5 = arr.a[i];
        $x_2.F(ys, $x_1, f(x0$5));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      while ((i < len)) {
        var $x_4 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_3 = i;
        var x0$6 = arr.a[i];
        $x_4.F(ys, $x_3, f(x0$6));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      while ((i < len)) {
        var $x_6 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_5 = i;
        var x0$7 = arr.a[i];
        $x_6.F(ys, $x_5, f(x0$7));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      while ((i < len)) {
        var $x_10 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_9 = i;
        var $x_7 = arr.a;
        var $x_8 = (i << 1);
        var x0$8_$_lo = $x_7[$x_8];
        var x0$8_$_hi = $x_7[(($x_8 + 1) | 0)];
        $x_10.F(ys, $x_9, f($j_java$002elang$002e$002dObject.$bL(x0$8_$_lo, x0$8_$_hi)));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      while ((i < len)) {
        var $x_12 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_11 = i;
        var x0$9 = arr.a[i];
        $x_12.F(ys, $x_11, f(x0$9));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      while ((i < len)) {
        var $x_14 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_13 = i;
        var x0$10 = arr.a[i];
        $x_14.F(ys, $x_13, f($j_java$002elang$002e$002dObject.$bC(x0$10)));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      while ((i < len)) {
        var $x_16 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_15 = i;
        var x0$11 = arr.a[i];
        $x_16.F(ys, $x_15, f(x0$11));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      while ((i < len)) {
        var $x_18 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_17 = i;
        var x0$12 = arr.a[i];
        $x_18.F(ys, $x_17, f(x0$12));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      while ((i < len)) {
        var $x_20 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_19 = i;
        var x0$13 = arr.a[i];
        $x_20.F(ys, $x_19, f(x0$13));
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(arr);
    }
  }
  return $x_23.u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits.$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($x_22, $x_21.yg(ys), $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]));
}
export { $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsTable$1__Lcom_raquo_airstream_state_Var__Ldev_cheleb_scalamigen_WidgetFactory__Ldev_cheleb_scalamigen_config_PanelConfig__sci_List__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_laminar_nodes_ReactiveHtmlElement as $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsTable$1__Lcom_raquo_airstream_state_Var__Ldev_cheleb_scalamigen_WidgetFactory__Ldev_cheleb_scalamigen_config_PanelConfig__sci_List__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_laminar_nodes_ReactiveHtmlElement };
function $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsPanel$1__Lcom_raquo_airstream_state_Var__sci_List__Ldev_cheleb_scalamigen_WidgetFactory__Lcom_raquo_airstream_eventbus_EventBus__sci_ArraySeq$ofRef($thiz, variable$14, path$11, factory$4, errorBus$9) {
  var $x_21 = $j_scala$002e$002dI$002dArray$0024package$0024$002dI$002dArray$0024.$m_s_IArray$package$IArray$();
  var arr = $thiz.jL.mh;
  var f = ((param$2) => {
    var isOption = (param$2.xc(variable$14.a4().b3().C()) instanceof $j_java$002elang$002e$002dObject.$c_s_Option);
    var fieldName = $p_Ldev_cheleb_scalamigen_Form$$anon$12__fieldNameFromParam__Lmagnolia1_CaseClass$Param__T($thiz, param$2);
    return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00241.$c_Ldev_cheleb_scalamigen_Form$$anon$1(fieldName, (!isOption), param$2.rq()).bt($j_java$002elang$002e$002dObject.$f_sc_StrictOptimizedSeqOps__appended__O__O(path$11, $j_scala$002e$002dUniqueness$002dCache.$c_s_UniquenessCache.prototype.O3.call($j_scala$002e$002dSymbol$0024.$m_s_Symbol$(), fieldName)), $p_Ldev_cheleb_scalamigen_Form$$anon$12__mkVariableForParam__Lcom_raquo_airstream_state_Var__Lmagnolia1_CaseClass$Param__Lcom_raquo_airstream_state_Var($thiz, variable$14, param$2), factory$4, errorBus$9), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.r3().w(param$2.k7)]));
  });
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.l();
  var len = arr.a.length;
  var componentType = evidence$1__runtimeClass;
  var ys = componentType.J.U(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_2 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_1 = i;
        var x0$1 = arr.a[i];
        $x_2.F(ys, $x_1, f(x0$1));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      while ((i < len)) {
        var $x_4 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_3 = i;
        var x0$2 = arr.a[i];
        $x_4.F(ys, $x_3, f(x0$2));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      while ((i < len)) {
        var $x_6 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_5 = i;
        var x0$3 = arr.a[i];
        $x_6.F(ys, $x_5, f(x0$3));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      while ((i < len)) {
        var $x_10 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_9 = i;
        var $x_7 = arr.a;
        var $x_8 = (i << 1);
        var x0$4_$_lo = $x_7[$x_8];
        var x0$4_$_hi = $x_7[(($x_8 + 1) | 0)];
        $x_10.F(ys, $x_9, f($j_java$002elang$002e$002dObject.$bL(x0$4_$_lo, x0$4_$_hi)));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      while ((i < len)) {
        var $x_12 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_11 = i;
        var x0$5 = arr.a[i];
        $x_12.F(ys, $x_11, f(x0$5));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      while ((i < len)) {
        var $x_14 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_13 = i;
        var x0$6 = arr.a[i];
        $x_14.F(ys, $x_13, f($j_java$002elang$002e$002dObject.$bC(x0$6)));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      while ((i < len)) {
        var $x_16 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_15 = i;
        var x0$7 = arr.a[i];
        $x_16.F(ys, $x_15, f(x0$7));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      while ((i < len)) {
        var $x_18 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_17 = i;
        var x0$8 = arr.a[i];
        $x_18.F(ys, $x_17, f(x0$8));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      while ((i < len)) {
        var $x_20 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_19 = i;
        var x0$9 = arr.a[i];
        $x_20.F(ys, $x_19, f(x0$9));
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(arr);
    }
  }
  return $x_21.yg(ys);
}
export { $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsPanel$1__Lcom_raquo_airstream_state_Var__sci_List__Ldev_cheleb_scalamigen_WidgetFactory__Lcom_raquo_airstream_eventbus_EventBus__sci_ArraySeq$ofRef as $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsPanel$1__Lcom_raquo_airstream_state_Var__sci_List__Ldev_cheleb_scalamigen_WidgetFactory__Lcom_raquo_airstream_eventbus_EventBus__sci_ArraySeq$ofRef };
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$$anon$12(caseClass$2) {
  this.jL = null;
  this.Hm = null;
  this.Hn = null;
  this.jL = caseClass$2;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_Form$$anon$12 as $c_Ldev_cheleb_scalamigen_Form$$anon$12 };
$p = $c_Ldev_cheleb_scalamigen_Form$$anon$12.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$$anon$12;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$$anon$12() {
}
export { $h_Ldev_cheleb_scalamigen_Form$$anon$12 as $h_Ldev_cheleb_scalamigen_Form$$anon$12 };
$h_Ldev_cheleb_scalamigen_Form$$anon$12.prototype = $p;
$p.dJ = (function() {
  return this.Hm;
});
$p.dt = (function(x$1) {
  this.Hm = x$1;
});
$p.du = (function(x$1) {
  this.Hn = x$1;
});
$p.dx = (function(label, required, factory) {
  return factory.cX(required, label);
});
$p.bt = (function(path, variable, factory, errorBus) {
  var this$1 = this.Hn;
  if (this$1.k()) {
    matchResult21: {
      var $x_1;
      var arr = this.jL.w9;
      _return: {
        var i = 0;
        while ((i < $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(arr))) {
          if (($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aQ(arr, i) instanceof $j_dev$002echeleb$002escalamigen$002e$002dPanel.$c_Ldev_cheleb_scalamigen_Panel)) {
            var idx = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var idx = (-1);
      }
      var x81 = ((idx === (-1)) ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aQ(arr, idx)));
      if (($j_java$002elang$002e$002dObject.$m_s_None$() === x81)) {
        var arr$1 = this.jL.w9;
        _return$1: {
          var i$1 = 0;
          while ((i$1 < $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(arr$1))) {
            if (($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aQ(arr$1, i$1) instanceof $j_dev$002echeleb$002escalamigen$002e$002dNo$002dPanel.$c_Ldev_cheleb_scalamigen_NoPanel)) {
              var idx$1 = i$1;
              break _return$1;
            }
            i$1 = ((1 + i$1) | 0);
          }
          var idx$1 = (-1);
        }
        var x78 = ((idx$1 === (-1)) ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aQ(arr$1, idx$1)));
        if (($j_java$002elang$002e$002dObject.$m_s_None$() === x78)) {
          var $x_1 = new $j_dev$002echeleb$002escalamigen$002econfig$002e$002dPanel$002dConfig.$c_Ldev_cheleb_scalamigen_config_PanelConfig(new $j_java$002elang$002e$002dObject.$c_s_Some(this.jL.wa.mi), true, "srf-field", "srf-label", "srf-panel");
          break matchResult21;
        }
        if ((x78 instanceof $j_java$002elang$002e$002dObject.$c_s_Some)) {
          var $x_1 = new $j_dev$002echeleb$002escalamigen$002econfig$002e$002dPanel$002dConfig.$c_Ldev_cheleb_scalamigen_config_PanelConfig($j_java$002elang$002e$002dObject.$m_s_None$(), x78.Q.lC, "srf-field", "srf-label", "srf-panel");
          break matchResult21;
        }
        throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x78);
      }
      if ((x81 instanceof $j_java$002elang$002e$002dObject.$c_s_Some)) {
        var value$1 = x81.Q;
        var $x_1 = new $j_dev$002echeleb$002escalamigen$002econfig$002e$002dPanel$002dConfig.$c_Ldev_cheleb_scalamigen_config_PanelConfig($j_scala$002e$002dOption$0024.$m_s_Option$().B9(value$1.lE), value$1.lD, "srf-field", "srf-label", "srf-panel");
        break matchResult21;
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x81);
    }
  } else {
    var $x_1 = this$1.C();
  }
  var panel = $x_1;
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(factory.y0(panel.lH), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.iD.hc(panel.lI), (panel.lF ? $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsTable$1__Lcom_raquo_airstream_state_Var__Ldev_cheleb_scalamigen_WidgetFactory__Ldev_cheleb_scalamigen_config_PanelConfig__sci_List__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, variable, factory, panel, path, errorBus) : $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits.$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d, $p_Ldev_cheleb_scalamigen_Form$$anon$12__renderAsPanel$1__Lcom_raquo_airstream_state_Var__sci_List__Ldev_cheleb_scalamigen_WidgetFactory__Lcom_raquo_airstream_eventbus_EventBus__sci_ArraySeq$ofRef(this, variable, path, factory, errorBus), $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()))]));
});
var $d_Ldev_cheleb_scalamigen_Form$$anon$12 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$$anon$12, "dev.cheleb.scalamigen.Form$$anon$12", ({
  j0: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$$anon$12 as $d_Ldev_cheleb_scalamigen_Form$$anon$12 };
